export default "__VITE_ASSET__p7J4jUtS__"